export default "__VITE_ASSET__CCfstBjC__"